const cautionLetter = {
  subject: "This is a caution ",
  body: "This is a caution ",
};

const reviewLetter = {
  subject: "This is a review ",
  body: "This is a review ",
};

const probationLetter = {
  subject: "This is a probation ",
  body: "This is a probation ",
};

const disciplinaryLetter = {
  subject: "This is a disciplinary ",
  body: "This is a disciplinary ",
};

const physicalThreatLetter = {
  subject: "This is a physicalThreat ",
  body: "This is a physicalThreat ",
};

const withdrawlLetter = {
  subject: "This is a withdrawl ",
  body: "This is a withdrawl ",
};

const admonishLetter = {
  subject: "This is a admonish ",
  body: "This is a admonish ",
};

const reinstateLetter = {
  subject: "This is a reinstate ",
  body: "This is a reinstate ",
};

const caseCompletionLetter = {
  subject: "This is a case completion ",
  body: "This is a case completion ",
};

export default function emailTemplate(template) {
  return template === "Caution Letter"
    ? cautionLetter
    : template === "Review Letter"
    ? reviewLetter
    : template === "Probation Letter"
    ? probationLetter
    : template === "Disciplinary Letter"
    ? disciplinaryLetter
    : template === "Disciplinary Letter - Physical Threat"
    ? physicalThreatLetter
    : template === "Withdrawl Letter"
    ? withdrawlLetter
    : template === "Admonish Letter"
    ? admonishLetter
    : template === "Reinstated Letter"
    ? reinstateLetter
    : template === "Case Completion Letter"
    ? caseCompletionLetter
    : null;
}
